import { mapGetters } from "vuex";

export default {
  name: "ProAgeCodeList",
  props: {},
  emits: [],
  components: {},
  setup() {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {
    ...mapGetters({
      content: "proAge/content",
    }),
  },
  methods: {
    scroll() {
      const element = document.querySelector(".pro-age__format--title");
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
          offset: { top: 30 },
        });
      }
    },
  },
};
